/**
 * 初始化目标值为 undefined 的属性
 * @param target 目标对象
 * @param dft 默认值对象
 */
export function initUndefined<T extends Record<string, any>, K extends keyof T>(target: T, dft: Required<Pick<T, K>>) {
  ;(Object.keys(dft) as K[]).forEach((key) => (target[key] = target[key] ?? dft[key]))
}
/**
 * 并发控制器
 * @param limit 最大并发数
 */
export class ConcurrencyController<T> {
  private limit: number
  private queue: (() => Promise<void>)[] = []
  private activeCount: number = 0

  constructor(limit: number) {
    this.limit = limit
  }

  async runTask(task: (...args: any[]) => Promise<T>, ...args: any[]): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      const executeTask = async () => {
        this.activeCount++
        try {
          const result = await task(...args)
          resolve(result)
        } catch (error) {
          reject(error)
        } finally {
          this.activeCount--
          this.runNext()
        }
      }

      if (this.activeCount < this.limit) {
        executeTask()
      } else {
        this.queue.push(executeTask)
      }
    })
  }

  private runNext() {
    if (this.queue.length > 0 && this.activeCount < this.limit) {
      const nextTask = this.queue.shift()
      if (nextTask) {
        nextTask()
      }
    }
  }
}
